import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listProductApi, addProductApi } from "../../auth/authService";

export const fetchMasterProducts = createAsyncThunk(
    "masterProducts/fetchMasterProducts ",
    async (params = {}, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;

            const {
                page = 1,
                per_page = 10,
                search = ""
            } = params;

            const res = await listProductApi(token, {
                page,
                per_page,
                search
            });

            return res;
        } catch (err) {
            console.log("ERROR:", err);
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data"
            );
        }
    }
);


export const createMasterProducts = createAsyncThunk(
    "masterProducts/create",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await addProductApi(payload);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const masterProductsSlice = createSlice({
    name: "masterProducts",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchMasterProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMasterProducts.fulfilled, (state, action) => {
                //console.log("FULLFILLED PAYLOAD:", action.payload);
                state.loading = false;
                state.data = action.payload.data;
                state.pagination = action.payload.pagination;
                //console.log("PAYLOAD:", action.payload);
            })
            .addCase(fetchMasterProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                //console.log("REJECTED:", action.payload);
            })
            .addCase(createMasterProducts.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    state.data.unshift(action.payload.data);
                }
            });
    },
});

export default masterProductsSlice.reducer;